// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_et-a";
export var fulfillmentFormRail = "_et-9";
export var headerTitleRow = "_et-c";
export var orderDetailsWrapper = "_et-7";
export var orderLinkTrigger = "_et-2";
export var paymentInformationGrid = "_et-h";
export var paymentSummaryColumn = "_et-i";
export var shipmentContainer = "_et-b";
export var shipmentDetailsMainPane = "_et-8";
export var shipmentNavigationCard = "_et-5";
export var shipmentNavigationRail = "_et-3";
export var shipmentNavigationRailHeader = "_et-4";
export var shipmentSummaryFact = "_et-e";
export var shipmentSummaryGrid = "_et-d";
export var shipmentSummaryMetadataRow = "_et-f";
export var shipmentSummaryTags = "_et-g";
export var shipmentWorkspace = "_et-0";
export var shipmentWorkspaceContent = "_et-6";
export var shipmentWorkspaceHeader = "_et-1";